import { render, staticRenderFns } from "./HomeViewMain.vue?vue&type=template&id=6b670ef7&"
import script from "./HomeViewMain.vue?vue&type=script&lang=js&"
export * from "./HomeViewMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports